import { GridCellParams, GridSingleSelectColDef } from '@mui/x-data-grid-pro';
import { v4 } from 'uuid';
import { advancedOperators } from '../../../Compounds/UpstackDataGrid/helpers';
import { Icon } from '../../../Atoms/Icon';
import { CustomerMap } from '../../../../store/CustomerMap';
import { DetailCTARenderer } from '../../../Compounds/UpstackDataGrid/CellRenderers';
import { ComponentName, getMetaData } from '../../../Compounds/DetailsDrawer/detailsDrawersHelpers';

const SALESFORCE_URL = process.env.REACT_APP_SALESFORCE_INSTANCE_URL;

export const DefaultCustomerMapGridColumnDefs: GridSingleSelectColDef[] = [
  {
    field: 'details',
    headerName: '',
    sortable: false,
    width: 65,
    filterable: false,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    renderCell: (params: GridCellParams) => (
      <DetailCTARenderer
        data={params}
        value={''}
        valueFormatted={''}
        state={{
          id: v4(),
          data: params.row,
          ...getMetaData({ name: ComponentName.CUSTOMER_MAP, id: params.row.customerId }),
          replace: true
        }}
      />
    ),
    hideable: false,
    disableReorder: true
  },
  {
    headerName: 'Salesforce Customer',
    field: 'sfdcCustomerName',
    flex: 3,
    minWidth: 240,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    sortable: true,
    filterable: true,
    filterOperators: advancedOperators(),
    renderCell: (params: GridCellParams<CustomerMap>) => (
      <a
        className="text-indigo"
        title="Open in Salesforce"
        href={`${SALESFORCE_URL}/lightning/r/Account/${params.row.sfdcCustomerSfId}/view`}
        target="_blank"
        rel="noopener noreferrer">
        <div className="flex items-center text-small">
          {params.row.sfdcCustomerName}
          <Icon type="external" />
        </div>
      </a>
    )
  },
  {
    headerName: 'RPM Customer',
    field: 'customerName',
    flex: 3,
    minWidth: 240,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    sortable: true,
    filterable: true,
    filterOperators: advancedOperators(),
    renderCell: (params: GridCellParams<CustomerMap>) => (
      <a
        className="text-indigo"
        title="Open in RPM"
        href={`${process.env.REACT_APP_RPM_URL}/rpm/Page/Customer.aspx?Item=${params.row.customerId}`}
        target="_blank"
        rel="noopener noreferrer">
        <div className="flex items-center text-small">
          {params.row.customerName}
          <Icon type="external" />
        </div>
      </a>
    )
  },
  {
    field: 'sfdcCustomerUid',
    headerName: 'Salesforce UID',
    sortable: true,
    filterable: true,
    flex: 2,
    minWidth: 287,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    filterOperators: advancedOperators(),
    description: 'Drag to move column'
  },
  {
    headerName: 'Ultimate Parent',
    field: 'sfdcUltimateParentAccountName',
    flex: 3,
    minWidth: 200,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    sortable: true,
    filterable: true,
    filterOperators: advancedOperators(),
    renderCell: (params: GridCellParams<CustomerMap>) =>
      params.row.sfdcUltimateParentAccountName ? (
        <a
          className="text-indigo"
          title="Open in Salesforce"
          href={`${SALESFORCE_URL}/lightning/r/Account/${params.row.sfdcUltimateParentAccountSfId}/view`}
          target="_blank"
          rel="noopener noreferrer">
          <div className="flex items-center text-small">
            {params.row.sfdcUltimateParentAccountName}
            <Icon type="external" />
          </div>
        </a>
      ) : (
        <span />
      )
  },
  {
    field: 'customerId',
    headerName: 'RPM Customer ID',
    sortable: true,
    filterable: true,
    flex: 1,
    minWidth: 100,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    filterOperators: advancedOperators(),
    description: 'Drag to move column'
  }
];
